import React, {useMemo} from "react";
import {CustomerAsideMenuList} from "./CustomerAsideMenuList";
import {useHtmlClassService} from "../../../_core/MetronicLayout";
import {shallowEqual, useSelector} from "react-redux";
import {AdminAsideMenuList} from "./AdminAsideMenuList";

export function AsideMenu({disableScroll}) {
    const uiService = useHtmlClassService();
    const layoutProps = useMemo(() => {
        return {
            layoutConfig: uiService.config,
            asideMenuAttr: uiService.getAttributes("aside_menu"),
            ulClasses: uiService.getClasses("aside_menu_nav", true),
            asideClassesFromConfig: uiService.getClasses("aside_menu", true)
        };
    }, [uiService]);

    const {userType} = useSelector(
        ({auth}) => ({
            isAuthorized: auth.user != null,
            userType: auth.user != null && auth.user.level
        }),
        shallowEqual
    );

    return (
        <>
            {/* begin::Menu Container */}
            <div
                id="kt_aside_menu"
                data-menu-vertical="1"
                className={`aside-menu my-4 ${layoutProps.asideClassesFromConfig}`}
                {...layoutProps.asideMenuAttr}
            >
                {userType === 1 && (
                    <AdminAsideMenuList layoutProps={layoutProps}/>
                )}
                {userType === 0 && (
                    <CustomerAsideMenuList layoutProps={layoutProps}/>
                )}

            </div>
            {/* end::Menu Container */}
        </>
    );
}
